import type { CollapsedSectionStatus } from "./CollapsedSectionRow.types";

export const COLLAPSED_ROW_COPY = {
  actionLabel: "Change",
  statusLabels: {
    done: "Done",
    attention: "Needs attention",
    blocked: "Blocked",
    none: "",
  } as Record<CollapsedSectionStatus, string>,
};
